<template>
  <transition
    class="transition-[opacity,transform] duration-[150ms]"
    :class="
      {
        'top-left': 'origin-top-left',
        'top-right': 'origin-top-right',
        'bottom-left': 'origin-bottom-left',
        'bottom-right': 'origin-bottom-right',
      }[origin]
    "
    enter-from-class="opacity-0 transform scale-50"
    enter-to-class="opacity-100 transform scale-100"
    leave-from-class="opacity-100 transform scale-100"
    leave-to-class="opacity-0 transform scale-50"
  >
    <slot></slot>
  </transition>
</template>

<script lang="ts" setup>
import { Origin } from './types';

withDefaults(
  defineProps<{
    origin?: Origin;
  }>(),
  {
    origin: 'top-left',
  }
);
</script>
